module.exports = __webpack_public_path__ + "img/BEST.66425185.png";